module.exports = __webpack_public_path__ + "static/img/square_logo.832a0125.png";